import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=45cf7ce0&scoped=true&"
import script from "./list-item.vue?vue&type=script&lang=ts&"
export * from "./list-item.vue?vue&type=script&lang=ts&"
import style0 from "./list-item.vue?vue&type=style&index=0&id=45cf7ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf7ce0",
  null
  
)

export default component.exports